import { render, staticRenderFns } from "./EnterTipsAudioWithOutBtn.vue?vue&type=template&id=9a941600&scoped=true&"
import script from "./EnterTipsAudioWithOutBtn.vue?vue&type=script&lang=js&"
export * from "./EnterTipsAudioWithOutBtn.vue?vue&type=script&lang=js&"
import style0 from "./EnterTipsAudioWithOutBtn.vue?vue&type=style&index=0&id=9a941600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a941600",
  null
  
)

export default component.exports